import type { Inventory } from "~/sources/inventory/types.internal";

export function generateInventorySlug(inventory: Inventory): string {
  const { id, make, model, trim } = inventory ?? {};

  if (!id || !make || !model || !trim) {
    throw new Error("Inventory is missing required fields");
  }

  return `${id}-${make}-${model}-${trim}`;
}

export function extractInventoryIdFromSlug(inventorySlug: string): number {
  if (!inventorySlug) {
    throw new Error("Inventory slug is required");
  }

  return Number(inventorySlug.split("-")?.[0]);
}
